var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"terms-checkbox"},[_c('input',{attrs:{"required":"","type":"checkbox"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(`${_vm.$t('text.terms')}*`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }